export const themeConfig = {
  // Brand colors
  primary: {
    main: "#1976d2", // Main blue
    light: "#42a5f5", // Light blue
    dark: "#1565c0", // Dark blue
  },

  secondary: {
    main: "#dc004e", // Main red
    light: "#e33371", // Light red
    dark: "#9a0036", // Dark red
  },

  // Status colors
  success: {
    main: "#4caf50", // Standard green
    light: "#81c784", // Light green
    dark: "#388e3c", // Dark green
    // Custom calm variations
    calm: "rgba(76, 175, 80, 0.85)", // 85% for buttons
    subtle: "rgba(76, 175, 80, 0.15)", // 15% for backgrounds
    medium: "rgba(76, 175, 80, 0.7)", // 70% for progress bars
    soft: "rgba(76, 175, 80, 0.2)", // 20% for progress backgrounds
  },

  error: {
    main: "#f44336",
    light: "#e57373",
    dark: "#d32f2f",
  },

  warning: {
    main: "#ff9800",
    light: "#ffb74d",
    dark: "#f57c00",
  },

  info: {
    main: "#2196f3",
    light: "#64b5f6",
    dark: "#1976d2",
  },

  // Backgrounds
  background: {
    default: "#f5f5f5",
    paper: "#ffffff",
  },

  // Text colors
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.6)",
    disabled: "rgba(0, 0, 0, 0.38)",
  },

  // Component-specific colors
  components: {
    // Topic tree colors
    topicTree: {
      primaryBorder: "#1976d2",
      secondaryBorder: "#dc004e",
      primaryBg: "rgba(25, 118, 210, 0.08)",
      secondaryBg: "rgba(220, 0, 78, 0.05)",
      hover: "rgba(0, 0, 0, 0.04)",
    },

    // Number badges
    badges: {
      background: "#ffffff",
      text: "#42a5f5", // primary.light
      border: "rgba(25, 118, 210, 0.2)",
    },

    // Subscription indicators
    subscription: {
      chipBg: "rgba(76, 175, 80, 0.15)",
      chipText: "#388e3c", // success.dark
      progressBg: "rgba(76, 175, 80, 0.2)",
      progressBar: "rgba(76, 175, 80, 0.7)",
      buttonBg: "rgba(76, 175, 80, 0.85)",
      buttonHover: "#4caf50", // success.main
    },
  },
};

// Helper function to generate theme overrides
export const getThemeOverrides = () => ({
  components: {
    // Global button overrides for consistent calm colors
    MuiButton: {
      styleOverrides: {
        containedSuccess: {
          backgroundColor: themeConfig.components.subscription.buttonBg,
          "&:hover": {
            backgroundColor: themeConfig.components.subscription.buttonHover,
          },
        },
      },
    },

    // Global chip overrides
    MuiChip: {
      styleOverrides: {
        colorSuccess: {
          backgroundColor: themeConfig.components.subscription.chipBg,
          color: themeConfig.components.subscription.chipText,
        },
      },
    },
  },
});

